import { actions } from 'react-redux-form';
import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { objectToListKey, newListSomeValue, getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { QUOTATION_BANDWIDTH as QuotationBandwidth } from '../../../../../utils/constant.utils';
import { getVendorDetails } from '../../order-request.functions';

import {
    quotationLocationModelA
    , quotationSubscriptionModelA
    , quotationBusinessModelA

    //ACTIONS
    , setCountryOptions
    , setRequestTypeOptions
    , setVendorOptions
    , setCircuitTypeOptions
    , setContractTermOptions
    , setBandwidthOptions
    , setVendorSelected
    , setCircuitTypeSelected
    , setContractTermSelected
    , setBandwidthSelected
    , setOtherBandwidthField
    , setPurposeOfUseOptions
    , setVendorDetails
    , setFormSubmitted
    , resetQuotationRequest
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-quotation.settings';

export const quotationLocationModelAInitialState = quotationLocationModelA;
export const quotationSubscriptionModelAInitialState = quotationSubscriptionModelA;
export const quotationBusinessModelAInitialState = quotationBusinessModelA;

const defaultState = () => ({
    countryOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , requestTypeOptions: []
    , vendorOptions: []
    , allVendorSelected: false
    , circuitTypeOptions: []
    , allCircuitTypeSelected: false
    , contractTermOptions: []
    , allContractTermSelected: false
    , bandwidthOptions: []
    , allBandwidthSelected: false
    , showOtherBandwidthField: false
    , purposeOfUseOptions: []
    , vendorDetails: {
        Currency: ''
    }
    , formSubmitted: false
});

const initialState = defaultState();

export const newQuotationActions = {
    getQuotationFormData: () => async (dispatch, state) => {

        const { requestTypeId } = state().createRequest;

        var data = {
            RequestTypeId: requestTypeId
            , User: { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);

        if (res != null) {
            dispatch({ type: setCountryOptions, data: res.Countries });
            dispatch({ type: setRequestTypeOptions, data: res.QuotationRequestType });
            dispatch({ type: setCircuitTypeOptions, data: res.QuotationCircuitType });
            dispatch({ type: setContractTermOptions, data: res.QuotationContractTerms });
            dispatch({ type: setBandwidthOptions, data: res.QuotationBandwidth });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
        }

    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryOptions } = state().quotationRequest;

        dispatch(actions.change(model, value));

        dispatch(actions.change('quotationLocationFormA.country', countryOptions.find(x => x.Key === value).Value));
        dispatch(actions.change('quotationLocationFormA.quotationAddress', ''));
        dispatch(actions.change('quotationLocationFormA.quotationAddress2', ''));
        getVendors(dispatch, state);

    }
    // quotation subscription
    , onVendorSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        //const value = target.value;
        const { preferredVendorOptions, allVendorSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;
        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationVendorListIds
            , allVendorSelected
            , preferredVendorOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationVendorListIds', selectedItems));
        dispatch({ type: setVendorSelected, data: selectedItems.length == preferredVendorOptions.length });
    }
    , onCircuitTypeSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        const { circuitTypeOptions, allCircuitTypeSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;

        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationCircuitTypeIds
            , allCircuitTypeSelected
            , circuitTypeOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationCircuitTypeIds', selectedItems));
        dispatch({ type: setCircuitTypeSelected, data: selectedItems.length == circuitTypeOptions.length });
    }
    , onContractTermSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        const { contractTermOptions, allContractTermSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;

        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationContractTermIds
            , allContractTermSelected
            , contractTermOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationContractTermIds', selectedItems));
        dispatch({ type: setContractTermSelected, data: selectedItems.length == contractTermOptions.length });
    }
    , onBandwidthSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        const { bandwidthOptions, allBandwidthSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;

        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationBandwidthIds
            , allBandwidthSelected
            , bandwidthOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationBandwidthIds', selectedItems));
        dispatch({ type: setBandwidthSelected, data: selectedItems.length == bandwidthOptions.length });

        let showOtherField = selectedItems.indexOf(QuotationBandwidth.other) > -1;

        dispatch({ type: setOtherBandwidthField, data: showOtherField });

        if (!showOtherField) {
            dispatch(actions.change('quotationSubscriptionFormA.quotationBandwidthOther', ''));
        }
    }
    , submitRequest: () => async (dispatch, state) => {

        const { requestTypeId, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { quotationLocationFormA
            , quotationSubscriptionFormA
            , quotationBusinessFormA
        } = state().form;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.UserId;
        }

        var data = {
            // this block is temporary so that request will not fail (need refactor on the backend)
            LocationOrderModel: {
                ...quotationLocationFormA
                , isWirelineRequest: isWirelineRequest
            }
            , SubscriptionModel: { ...quotationSubscriptionFormA }
            , BusinessJustificationModel: { ...quotationBusinessFormA }
            // end

            , User: { ...userData }
            , NoEmail: true
            , RequestTypeId: requestTypeId
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , resetQuotationForm: () => (dispatch) => {
        resetForm(dispatch);
        dispatch({ type: resetQuotationRequest, data: false });
        dispatch({ type: setFormSubmitted, data: false });
    }
}

async function getVendors(dispatch, state) {

    const { isWirelineRequest } = state().createRequest;
    const { quotationLocationFormA } = state().form;

    var data = {
        ...quotationLocationFormA
        , IsWirelineRequest: isWirelineRequest
    };

    var res = await httpPost('external/orderRequest/getVendors', data);
    if (res.ok == undefined && res.PrefVendors.length > 0) {
        dispatch({
            type: setVendorOptions
            , prefVendors: res.PrefVendors
            , nonPrefVendors: res.NonPrefVendors
        });
        if (res.PrefVendors[0].Key != 0) {
            dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', res.PrefVendors[0].Key));
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, res.PrefVendors[0].Key);
        }
    }
}



function getNewSelectedValues(id, selectedValues, isSelectAll, options) {

    let newSelectedValues = [];
    let exist = objectToListKey(options).find(x => x == id);

    if (id == "" || exist == undefined) {
        newSelectedValues = isSelectAll ? [] : objectToListKey(options);
    } else {
        newSelectedValues = newListSomeValue(parseInt(id), selectedValues);
    }

    return newSelectedValues;
}

function resetForm(dispatch) {

    dispatch(actions.reset('quotationLocationFormA'));
    dispatch(actions.reset('quotationSubscriptionFormA'));
    dispatch(actions.reset('quotationBusinessFormA'));

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCountryOptions:
            return {
                ...state,
                countryOptions: action.data
            };
        case setRequestTypeOptions:
            return {
                ...state,
                requestTypeOptions: action.data
            };
        case setVendorOptions:
            return {
                ...state,
                preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setVendorSelected:
            return {
                ...state,
                allVendorSelected: action.data
            };
        case setCircuitTypeOptions:
            return {
                ...state,
                circuitTypeOptions: action.data
            };
        case setCircuitTypeSelected:
            return {
                ...state,
                allCircuitTypeSelected: action.data
            };
        case setContractTermOptions:
            return {
                ...state,
                contractTermOptions: action.data
            };
        case setContractTermSelected:
            return {
                ...state,
                allContractTermSelected: action.data
            };
        case setBandwidthOptions:
            return {
                ...state,
                bandwidthOptions: action.data
            };
        case setBandwidthSelected:
            return {
                ...state,
                allBandwidthSelected: action.data
            };
        case setOtherBandwidthField:
            return {
                ...state,
                showOtherBandwidthField: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case resetQuotationRequest:
            return {
                ...state,
                allVendorSelected: action.data
                , allCircuitTypeSelected: action.data
                , allContractTermSelected: action.data
                , allBandwidthSelected: action.data
            };  
        default: return state;
    }
}